import React, {useState, useEffect} from 'react'
import { Grid, Typography, CircularProgress, Button } from "@material-ui/core";
import { connect } from "react-redux";
import * as actions from "../../store/actions/actionIndex";
// styles
import useStyles from "./styles";
import logo from "./logo.png";
import {localStorageFunc, decryptData } from '../../helpers/utility';
import { ToastContainer } from 'react-toastify';

function TokenLogin(props) {
    var classes = useStyles();
	const [reset, setRest] = useState(false)
	const [open, setOpen] = useState(false);
    const [controls, setControls] = useState({
		email: {
		  value: "", 
		},
		password: {
		  value: "",
		},
	  });

	  const LogoutUrl = async() =>{
    const url = await decryptData();
	localStorage.clear("accessToken");
	return window.location.href = url.logoutURL;
	
	  }
      const agentId = localStorageFunc.get("agentId");
      const loginHandler = (action) => {
		if (action === "no") {
			setControls({
				email: {
					value: "",
				},
				password: {
					value: "",
				},
			});
			props.onAuth(agentId, "", "", "newlogin" , 0);
		} else if (action === "yes") {
			props.onAuth(agentId, "", "", "relogin", 0);
		}
	};
 // Open the Reset Password option
	useEffect(()=>{
		if(props.isExpired === true){
			setOpen(true)
		}
	},[props.isExpired, reset])

	//Run on Auth API after verfiy user email
     useEffect(() =>{
        if((props.responseCode === "1" ||props.responseCode === "2")){
                props.onAuth(controls.email.value, "", "", "", 0);
                }
        },[props.responseCode, reset])

		const handleClose = () =>{
		setOpen(false);
		setRest(false);
		
	}
	
    return (
		<>
		<ToastContainer />
        <Grid container className={classes.container}>

            <div className={classes.loginPage}>
                <div className={classes.logoParent}>
                    <img src={logo} alt="logo" className={classes.logotypeImage} />
                </div>
                <Typography className={classes.mainText}>C-Zentrix Telephony Solution</Typography>
                <div className='callIcon'>				
			<Typography className={classes.subGreeting}>
			{(props.error && props.error.includes("does not exist") ? "Oops!" : "Waiting for the Telephony " )}
			</Typography>
{/*             
                <WifiCalling3Icon/> */}
                </div>
                <Typography color="primary" className={classes.para}>
               {(props.error === "ReloginAgent" ? "Agent is already login. Do you want to create new session?" : props.error) }
                </Typography>
            
				{props.error && props.error.includes("does not exist.") && (
					<div className={classes.loginbox}>
				<Button className={classes.loginButton} onClick={ () => LogoutUrl()} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
				Try Again
				{props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
			</Button>
			</div>	
				)}

            {props.error === "ReloginAgent" && (
								<>
				<div className={classes.loginbox}>
						<Button className={classes.loginButton} onClick={() => loginHandler("yes")} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
							Yes
						{props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
						</Button>
						<Button className={classes.loginButton} onClick={() => loginHandler("no")} variant="contained" color="primary" size="large" style={{ flex: "auto" }}>
						No
						{props.loading ? <CircularProgress size={26} className={classes.loginLoader} /> : ""}
						</Button>
						</div>
						</>
							)}

			</div>
       		 </Grid>
			 	</>
);
}

const mapStateToProps = (state) => {
	return {
		loading: state.agentData.loading,
		error: state.agentData.error,
		status: state.agentData.status,
		isAuthenticated: state.agentData.loggedIn,
		loginWait: state.agentData.loginWait,
		loginType: state.agentData.loginType,
		agentId: state.agentData.agentId,
		//authRedirectPath: state.agentData.authRedirectPath,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onAuth: (email, password, extension, action, session_flag) => dispatch(actions.agentLogin(email, password, extension, action, session_flag)),
		//onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/')),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenLogin);
